// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watch-now-button .basic-button[data-v-06138bba]:hover{background-color:#fbd446}", ""]);
// Exports
module.exports = exports;
